/* eslint-disable jira/naming/disallow-filenames */
import type { RouteContext } from '@atlassian/react-resource-router';
import {
	SERVICE_DESK_PRODUCT,
	defaultRedirectForSettings,
} from '../ui/product-routes/common/index.tsx';

export const FedRAMPFallbackRedirectToProjectSettings: ({
	match,
}: RouteContext) => React.JSX.Element = defaultRedirectForSettings(SERVICE_DESK_PRODUCT);
